import Select from 'react-select'
import { Modal, Button } from 'react-bootstrap';

const InventoryCalculationTable = ({
    consumptionData,
    fetchItemData,
    itemSearchTerm,
    setItemSearchTerm,
    filter,
    setFilter,
    groupSearchTerm,
    setGroupSearchTerm,
    handleReceivedClick,
    inventoryData,
    handleSave,
    handleOpeningClick,
    allZero,
    handleWastageClick,
    handleFetchDetails,
    handlePhysicalClick,
    itemDetails,
    showModal,
    setShowModal,
    foodPercentage,
    foodRecipeCount,
    totalFoodItems,
    beveragePercentage,
    beverageRecipeCount,
    totalBeverageItems,
    getPhysicalFromSaved
}) => {
    const disableSave = filter !== 'All';

    const formattedDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);

        const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
        const day = date.getDate();
        const getOrdinal = (n) => {
            if (n > 3 && n < 21) return `${n}th`;
            switch (n % 10) {
                case 1: return `${n}st`;
                case 2: return `${n}nd`;
                case 3: return `${n}rd`;
                default: return `${n}th`;
            }
        };
        const dayWithOrdinal = getOrdinal(day);
        const month = date.toLocaleDateString("en-US", { month: "long" });
        const year = date.getFullYear();

        return `${weekday}, ${dayWithOrdinal} ${month}, ${year}`;
    };

    return (
        <>
            <div className="grid grid-cols-4 gap-4 mt-4 text-sm">
                <div className="border p-2">
                    <div className="font-bold mb-2 text-base text-center">FOOD</div>
                    <div className="rounded-md border overflow-x-auto max-h-[400px]">
                        <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Item Name</th>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Sold</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {consumptionData.grouped_by_item_type?.Food?.itemwise_summary?.length > 0 ? (
                                    consumptionData.grouped_by_item_type.Food.itemwise_summary.map((item, index) => (
                                        <tr
                                            key={index}
                                            className={`hover:bg-gray-50 hover:underline cursor-pointer ${!item.has_recipe ? 'bg-red-100 text-red-700 hover:text-red-800' : ''}`}
                                            onClick={() => fetchItemData(item)}
                                        >
                                            <td className="px-3 py-2">
                                                <div >
                                                    {item.ItemName}
                                                </div>
                                            </td>
                                            <td className="px-3 py-2">{item.total_sold}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={2} className="px-3 py-4 text-gray-500">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="mt-2 p-1 space-y-1">
                        <div className='grid grid-cols-2 gap-2 items-center'>
                            <label className="mr-2">Total items :</label>
                            <input
                                type="text"
                                readOnly
                                value={totalFoodItems}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label className="mr-2">Missing items :</label>
                            <input
                                type="text"
                                readOnly
                                value={foodRecipeCount}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label className="mr-2">Accuracy :</label>
                            <input
                                type="text"
                                readOnly
                                value={`${foodPercentage}%`}
                                className={`border p-1 rounded w-full font-semibold text-center ${foodPercentage < 80 ? 'bg-red-200 text-red-800' :
                                    foodPercentage >= 80 && foodPercentage <= 90 ? 'bg-yellow-200 text-yellow-800' :
                                        'bg-green-200 text-green-800'
                                    }`}
                            />
                        </div>
                    </div>
                </div>

                <div className="border p-2">
                    <div className="font-bold mb-2 text-base text-center">FOOD CONSUMPTION</div>
                    <div className="rounded-md border overflow-x-auto max-h-[400px]">
                        <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Item</th>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Amount</th>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">UOM</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {consumptionData.type_wise_consumption?.Food && Object.keys(consumptionData.type_wise_consumption.Food).length > 0 ? (
                                    Object.entries(consumptionData.type_wise_consumption.Food).map(([item, details], index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="px-3 py-2">{item}</td>
                                            <td className="px-3 py-2">{details.total_quantity}</td>
                                            <td className="px-3 py-2">{details.uom}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} className="px-3 py-4 text-gray-500">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="border p-2">
                    <div className="font-bold mb-2 text-base text-center">BEVERAGE</div>
                    <div className="rounded-md border overflow-x-auto max-h-[400px]">
                        <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Item Name</th>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Sold</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {consumptionData.grouped_by_item_type?.Beverage?.itemwise_summary?.length > 0 ? (
                                    consumptionData.grouped_by_item_type.Beverage.itemwise_summary.map((item, index) => (
                                        <tr
                                            key={index}
                                            className={`hover:bg-gray-50 hover:underline cursor-pointer ${!item.has_recipe ? 'bg-red-100 text-red-700 hover:text-red-800' : ''}`}
                                            onClick={() => fetchItemData(item)}
                                        >
                                            <td className="px-3 py-2">{item.ItemName}</td>
                                            <td className="px-3 py-2">{item.total_sold}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={2} className="px-3 py-4 text-gray-500">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="mt-2 p-1 space-y-1">
                        <div className='grid grid-cols-2 gap-2 items-center'>
                            <label className="mr-2">Total items :</label>
                            <input
                                type="text"
                                readOnly
                                value={totalBeverageItems}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label className="mr-2">Missing items :</label>
                            <input
                                type="text"
                                readOnly
                                value={beverageRecipeCount}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label className="mr-2">Accuracy :</label>
                            <input
                                type="text"
                                readOnly
                                value={`${beveragePercentage}%`}
                                className={`border p-1 rounded w-full font-semibold text-center ${beveragePercentage < 80 ? 'bg-red-200 text-red-800' :
                                    beveragePercentage >= 80 && beveragePercentage <= 90 ? 'bg-yellow-200 text-yellow-800' :
                                        'bg-green-200 text-green-800'
                                    }`}
                            />
                        </div>
                    </div>
                </div>

                <div className="border p-2">
                    <div className="font-bold mb-2 text-base text-center">BEVERAGE CONSUMPTION</div>
                    <div className="rounded-md border overflow-x-auto max-h-[400px]">
                        <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Item</th>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Amount</th>
                                    <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">UOM</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {consumptionData.type_wise_consumption?.Beverage && Object.keys(consumptionData.type_wise_consumption.Beverage).length > 0 ? (
                                    Object.entries(consumptionData.type_wise_consumption.Beverage).map(([item, details], index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="px-3 py-2">{item}</td>
                                            <td className="px-3 py-2">{details.total_quantity}</td>
                                            <td className="px-3 py-2">{details.uom}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} className="px-3 py-4 text-gray-500">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="mt-10 flex items-center justify-between">
                <div className='w-80 z-50'>
                    <Select
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        options={
                            inventoryData?.summary && Object.entries(inventoryData.summary).length > 0
                                ? Object.entries(inventoryData.summary)
                                    .flatMap(([category, groups]) =>
                                        Object.entries(groups).flatMap(([groupName, items]) =>
                                            items.map(item => ({
                                                value: item.name,
                                                label: item.name
                                            }))
                                        )
                                    )
                                    .filter((option, index, self) =>
                                        index === self.findIndex((t) => (
                                            t.value === option.value
                                        ))
                                    )
                                : []
                        }
                        isClearable
                        isSearchable
                        placeholder="Search item..."
                        onChange={(selectedOption) => setItemSearchTerm(selectedOption?.value || "")}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                minHeight: '40px',
                            }),
                        }}
                    />
                </div>

                <div className='flex items-center space-x-4'>
                    <label className="flex items-center space-x-2">
                        <input
                            type="radio"
                            name="filter"
                            value="Food"
                            checked={filter === 'Food'}
                            onChange={() => setFilter('Food')}
                        />
                        <span>Food</span>
                    </label>
                    <label className="flex items-center space-x-2">
                        <input
                            type="radio"
                            name="filter"
                            value="Beverage"
                            checked={filter === 'Beverage'}
                            onChange={() => setFilter('Beverage')}
                        />
                        <span>Beverage</span>
                    </label>
                    <label className="flex items-center space-x-2">
                        <input
                            type="radio"
                            name="filter"
                            value="All"
                            checked={filter === 'All'}
                            onChange={() => setFilter('All')}
                        />
                        <span>All</span>
                    </label>
                </div>

                <div className='w-64 z-50'>
                    <Select
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        options={
                            inventoryData?.summary && Object.entries(inventoryData.summary).length > 0
                                ? Object.entries(inventoryData.summary)
                                    .flatMap(([category, groups]) =>
                                        Object.keys(groups).map(groupName => ({
                                            value: groupName,
                                            label: groupName
                                        }))
                                    )
                                    .filter((option, index, self) =>
                                        index === self.findIndex((t) => (
                                            t.value === option.value
                                        ))
                                    )
                                : []
                        }
                        isClearable
                        isSearchable
                        placeholder="Search group..."
                        onChange={(selectedOption) => setGroupSearchTerm(selectedOption?.value || "")}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                minHeight: '40px',
                            }),
                        }}
                    />
                </div>

                <div className='flex gap-2 items-center'>
                    <button
                        disabled={disableSave || !inventoryData?.summary}
                        className={`border-2 border-slate-300 hover:bg-slate-100 bg-slate-700 text-zinc-100 hover:text-zinc-700 rounded-lg flex items-center justify-center px-3 py-2 text-sm ${disableSave || !inventoryData?.summary ? 'opacity-50 cursor-not-allowed' : ''}`}
                        onClick={handleSave}
                    >
                        Save
                    </button>

                    <button
                        onClick={handleReceivedClick}
                        className={`border-2 border-slate-300 hover:bg-slate-100 bg-slate-700 text-zinc-100 hover:text-zinc-700 rounded-lg flex items-center justify-center px-3 py-2 text-sm`}
                    >
                        Receive Stocks
                    </button>

                    <button
                        onClick={handleOpeningClick}
                        disabled={!allZero}
                        className={`border-2 border-slate-300 hover:bg-slate-100 bg-slate-700 text-zinc-100 hover:text-zinc-700 rounded-lg flex items-center justify-center px-3 py-2 text-sm ${!allZero ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                        Add Opening
                    </button>

                    <button
                        onClick={handleWastageClick}
                        className={`border-2 border-slate-300 hover:bg-slate-100 bg-slate-700 text-zinc-100 hover:text-zinc-700 rounded-lg flex items-center justify-center px-3 py-2 text-sm`}
                    >
                        Wastage
                    </button>

                    <button
                        onClick={handlePhysicalClick}
                        className={`border-2 border-slate-300 hover:bg-slate-100 bg-slate-700 text-zinc-100 hover:text-zinc-700 rounded-lg flex items-center justify-center px-3 py-2 text-sm`}
                    >
                        Physical Count
                    </button>
                </div>
            </div>

            <div className="mt-4 rounded-md border mb-4">
                <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                    <thead className="bg-gray-100 bg-opacity-100 shadow-md sticky top-1 z-40">
                        <tr>
                            {["Group", "Item Name", "UOM",
                                <span>Opening<br />({formattedDate(inventoryData.period?.start_date)})</span>,
                                "Received", "Wastage", "Consumption",
                                <span>Current Level<br />({formattedDate(inventoryData.period?.end_date)})</span>,
                                "Physical", "Discrepancy"].map((col, idx) => (
                                    <th
                                        key={idx}
                                        className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider"
                                    >
                                        {col}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                        {inventoryData?.summary && Object.entries(inventoryData.summary).length > 0 ? (
                            Object.entries(inventoryData.summary)
                                .filter(([category]) =>
                                    filter === 'All' ||
                                    (filter === 'Food' && category === 'Food') ||
                                    (filter === 'Beverage' && category === 'Beverage')
                                )
                                .flatMap(([category, groups]) =>
                                    Object.entries(groups)
                                        .filter(([groupName]) =>
                                            !groupSearchTerm || groupName.toLowerCase().includes(groupSearchTerm.toLowerCase())
                                        )
                                        .flatMap(([groupName, items]) =>
                                            items
                                                .filter(item =>
                                                    !itemSearchTerm || item.name.toLowerCase().includes(itemSearchTerm.toLowerCase())
                                                )
                                                .map((item) => {
                                                    const key = `${category}-${groupName}-${item.name}`;

                                                    const formatQuantity = (quantity) => {
                                                        if (!quantity || !item.unitdefinition?.unit || !item.unitdefinition?.uom) {
                                                            return `${quantity || 0}`;
                                                        }

                                                        const kgVariations = ['kg', 'kgs', 'kilogram', 'kilograms'];
                                                        const gramVariations = ['g', 'gram', 'grams', 'gm', 'gms', 'grm', 'grms'];
                                                        const literVariations = ['l', 'ltr', 'ltrs', 'liter', 'liters', 'litre', 'litres'];
                                                        const milliliterVariations = ['ml', 'milliliter', 'milliliters', 'millilitre', 'millilitres', 'mls'];

                                                        const areUnitsEquivalent = (unit1, unit2) => {
                                                            if (!unit1 || !unit2) return false;
                                                            const lower1 = unit1.toLowerCase();
                                                            const lower2 = unit2.toLowerCase();
                                                            if (kgVariations.includes(lower1) && kgVariations.includes(lower2)) return true;
                                                            if (gramVariations.includes(lower1) && gramVariations.includes(lower2)) return true;
                                                            if (literVariations.includes(lower1) && literVariations.includes(lower2)) return true;
                                                            if (milliliterVariations.includes(lower1) && milliliterVariations.includes(lower2)) return true;
                                                            return lower1 === lower2;
                                                        };

                                                        const isNegative = parseFloat(quantity) < 0;
                                                        const absQuantity = Math.abs(parseFloat(quantity));

                                                        if (areUnitsEquivalent(item.uom, item.unitdefinition.uom) &&
                                                            areUnitsEquivalent(item.new_uom, item.unitdefinition.uom) &&
                                                            areUnitsEquivalent(item.uom, item.new_uom)) {
                                                            return `${quantity}`;
                                                        }

                                                        if (!areUnitsEquivalent(item.uom, item.unitdefinition.uom) &&
                                                            areUnitsEquivalent(item.new_uom, item.unitdefinition.uom)) {
                                                            return originalFormatLogic(absQuantity, isNegative);
                                                        }

                                                        if (areUnitsEquivalent(item.uom, item.unitdefinition.uom) &&
                                                            !areUnitsEquivalent(item.new_uom, item.unitdefinition.uom)) {
                                                            return convertToMainPlusSubUnits(absQuantity, isNegative);
                                                        }

                                                        return handleCompatibleMainPlusSubUnits(absQuantity, isNegative);

                                                        function originalFormatLogic(qty, negative) {
                                                            const unitSize = parseFloat(item.unitdefinition.unit);

                                                            if (Number.isInteger(qty)) {
                                                                return `${negative ? '-' : ''}${qty}`;
                                                            }

                                                            if (qty < 1) {
                                                                const subQty = Math.round(qty * unitSize);
                                                                return `${negative ? '-' : ''}${subQty} ${item.unitdefinition.uom}`;
                                                            }

                                                            const mainUnits = Math.floor(qty);
                                                            const subUnits = Math.round((qty - mainUnits) * unitSize);

                                                            return (
                                                                <div>
                                                                    {negative && '-'}
                                                                    {mainUnits > 0 && `${mainUnits} ${item.uom}`}
                                                                    {mainUnits > 0 && subUnits > 0 && ' + '}
                                                                    {subUnits > 0 && `${subUnits} ${item.unitdefinition.uom}`}
                                                                    {mainUnits === 0 && subUnits === 0 && `0 ${item.uom}`}
                                                                </div>
                                                            );
                                                        }

                                                        function convertToMainPlusSubUnits(qty, negative) {
                                                            const unitSize = parseFloat(item.unitdefinition.unit);
                                                            let mainValue, subValue;

                                                            if ((kgVariations.some(v => item.uom.toLowerCase().includes(v)) &&
                                                                gramVariations.some(v => item.new_uom.toLowerCase().includes(v)))) {
                                                                mainValue = Math.floor(qty);
                                                                subValue = Math.round((qty - mainValue) * 1000 * unitSize);
                                                            }
                                                            else if ((literVariations.some(v => item.uom.toLowerCase().includes(v)) &&
                                                                milliliterVariations.some(v => item.new_uom.toLowerCase().includes(v)))) {
                                                                mainValue = Math.floor(qty);
                                                                subValue = Math.round((qty - mainValue) * 1000 * unitSize);
                                                            }
                                                            else {
                                                                return `${negative ? '-' : ''}${qty}`;
                                                            }

                                                            return (
                                                                <div>
                                                                    {negative && '-'}
                                                                    {mainValue > 0 && `${mainValue} ${item.uom}`}
                                                                    {mainValue > 0 && subValue > 0 && ' + '}
                                                                    {subValue > 0 && `${subValue} ${item.new_uom}`}
                                                                    {mainValue === 0 && subValue === 0 && `0 ${item.uom}`}
                                                                </div>
                                                            );
                                                        }

                                                        function handleCompatibleMainPlusSubUnits(qty, negative) {
                                                            const unitSize = parseFloat(item.unitdefinition.unit);
                                                            let mainValue, subValue;

                                                            if ((kgVariations.some(v => item.unitdefinition.uom.toLowerCase().includes(v)) &&
                                                                gramVariations.some(v => item.new_uom.toLowerCase().includes(v)))) {
                                                                mainValue = Math.floor(qty);
                                                                subValue = Math.round((qty - mainValue) * 1000 * unitSize);
                                                            }
                                                            else if ((literVariations.some(v => item.unitdefinition.uom.toLowerCase().includes(v)) &&
                                                                milliliterVariations.some(v => item.new_uom.toLowerCase().includes(v)))) {
                                                                mainValue = Math.floor(qty);
                                                                subValue = Math.round((qty - mainValue) * 1000 * unitSize);
                                                            }
                                                            else {
                                                                return `${negative ? '-' : ''}${qty}`;
                                                            }

                                                            return (
                                                                <div>
                                                                    {negative && '-'}
                                                                    {mainValue > 0 && `${mainValue} ${item.uom}`}
                                                                    {mainValue > 0 && subValue > 0 && ' + '}
                                                                    {subValue > 0 && `${subValue} ${item.new_uom}`}
                                                                    {mainValue === 0 && subValue === 0 && `0 ${item.uom}`}
                                                                </div>
                                                            );
                                                        }
                                                    };

                                                    return (
                                                        <tr key={key} className="hover:bg-gray-100">
                                                            <td className="px-3 py-2">{groupName}</td>
                                                            <td
                                                                className="px-3 py-2 hover:cursor-pointer hover:underline"
                                                                onClick={() => handleFetchDetails(item)}
                                                            >
                                                                {item.name}
                                                            </td>
                                                            <td className="px-3 py-2">{item.uom}</td>
                                                            <td className="px-3 py-2">{formatQuantity(item.opening)}</td>
                                                            <td className="px-3 py-2">{formatQuantity(item.total_received)}</td>
                                                            <td className="px-3 py-2">{formatQuantity(item.total_wasted)}</td>
                                                            <td className="px-3 py-2">{formatQuantity(item.total_consumed)}</td>
                                                            <td className="px-3 py-2">{formatQuantity(item.closing_balance)}</td>
                                                            <td className="px-3 py-2">{formatQuantity(getPhysicalFromSaved(item.name))}</td>
                                                            <td className="px-3 py-2">
                                                                {(() => {
                                                                    const physicalCount = Number(getPhysicalFromSaved(item.name));
                                                                    if (physicalCount > 0) {
                                                                        return formatQuantity(physicalCount - Number(item.closing_balance));
                                                                    }
                                                                    return 0;
                                                                })()}
                                                            </td>

                                                        </tr>
                                                    );
                                                })
                                        )
                                )
                        ) : (
                            <tr>
                                <td colSpan={10} className="px-3 py-4 text-gray-500">No data available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {itemDetails?.item_name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className='text-center'>
                        From <strong>{itemDetails?.start_date}</strong> to <strong>{itemDetails?.end_date}</strong>
                    </p>

                    <div className="rounded-md border overflow-x-auto">
                        <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                            <thead className="bg-gray-100">
                                <tr>
                                    {["Recipe Item", "Item Type", "Total Sold", "UOM", "Recipe Usage", "Sub-Recipe Item", "Sub-Recipe Usage", "Total Consumed"].map((col, idx) => (
                                        <th
                                            key={idx}
                                            className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider"
                                        >
                                            {col}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {itemDetails?.consumption_details?.details?.length > 0 ? (
                                    itemDetails.consumption_details.details.map((detail, idx) => {
                                        const subRecipeCount = detail.sub_recipes?.length || 0;
                                        const hasSubRecipes = subRecipeCount > 0;

                                        const rowCount = Math.max(1, subRecipeCount);

                                        return Array.from({ length: rowCount }).map((_, rowIndex) => (
                                            <tr key={`${idx}-${rowIndex}`} className="hover:bg-gray-50">
                                                {rowIndex === 0 ? (
                                                    <>
                                                        <td className="px-3 py-2" rowSpan={rowCount}>{detail.recipe_item}</td>
                                                        <td className="px-3 py-2" rowSpan={rowCount}>{detail.item_type}</td>
                                                        <td className="px-3 py-2" rowSpan={rowCount}>{detail.total_sold}</td>
                                                        <td className="px-3 py-2" rowSpan={rowCount}>{detail.converted_uom}</td>
                                                        <td className="px-3 py-2" rowSpan={rowCount}>{detail.total_direct_recipe_usage.toFixed(2)}</td>
                                                    </>
                                                ) : null}

                                                {hasSubRecipes ? (
                                                    <>
                                                        <td className="px-3 py-2">{detail.sub_recipes[rowIndex]?.sub_recipe_name || ''}</td>
                                                        <td className="px-3 py-2">
                                                            {detail.sub_recipes[rowIndex] ?
                                                                ((detail.total_sold * detail.sub_recipes[rowIndex].calculated_quantity).toFixed(2) || detail.total_sub_recipe_usage) : ''}
                                                        </td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td className="px-3 py-2">{rowIndex === 0 ? 'Not used' : ''}</td>
                                                        <td className="px-3 py-2">{rowIndex === 0 ? '0' : ''}</td>
                                                    </>
                                                )}

                                                {rowIndex === 0 ? (
                                                    <td className="px-3 py-2" rowSpan={rowCount}>{detail.total_consumed}</td>
                                                ) : null}
                                            </tr>
                                        ));
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={8} className="px-3 py-4 text-gray-500">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="text-end text-sm mt-3">
                        <strong>Total Consumed: </strong>
                        {itemDetails?.consumption_details?.summary?.total_consumed} {itemDetails?.consumption_details?.summary?.uom}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default InventoryCalculationTable